import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="phone-number-validator"
export default class extends Controller {
  static targets = ["input"];
  connect() {
    this.wait_for_assets(() => {
      const input = this.inputTarget;
      const onlyCountries = input.dataset.onlyCountries ? JSON.parse(input.dataset.onlyCountries) : []
      let iti = window.intlTelInput(input, {
        initialCountry: input.dataset.initialCountry,
        preferredCountries: [],
        onlyCountries,
        hiddenInput: input.dataset.hiddenInput || 'full_value',
        utilsScript: 'https://cdn.jsdelivr.net/npm/intl-tel-input@17.0.16/build/js/utils.min.js'
      });

      input.oninput = function(e) {
        if (!e.target.value) {
          input.setCustomValidity('')
        } else {
          input.setCustomValidity(iti.isValidNumber() ? '' : 'invalid-number')
        }
      }
    });
  }

  wait_for_assets(callback) {
    const check = () => {
      if (window.intlTelInput) {
        callback();
      } else {
        requestAnimationFrame(check); // try again on the next frame
      }
    };
    check();
  }
}